// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiBaseUrl: 'https://api.partner.truventor.com',
  // apiBaseUrl: 'http://localhost:3000',
  uiBaseUrl: 'https://dev.partner.truventor.com', //partner-fe
  cadViewerBase: 'https://dev.design.truventor.com/',
  cadViewerBase_deprecated: 'https://cad.truventor.com',
  designUrl: 'https://dev.design.truventor.com/',
  safeUrl: "https://dev.engage.truventor.com/", //engage-fe
  tOneUrl: 'https://dev.one.truventor.com',
  tOneAdminUrl: 'https://dev.admin.one.truventor.com',
  customerUrl: 'https://api.customer.truventor.com/',
  truventorStaticAssetCdnDomain:'https://truventor-static-assets-dxe8cqaaeyeqgvab.z02.azurefd.net/',
  adminBaseUrl: 'https://api.admin.truventor.com',
  engageApiUrl: 'https://api.engage.backend.truventor.com/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
